import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cn } from "@/lib/utils"

const Label = React.forwardRef(({ className, children, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}

    className={cn(
      "text-sm font-medium leading-none mb-1.5 peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className
    )}
    {...props}
  >
      {children}
    {props.required && <span className="text-red-500">*</span>}
  </LabelPrimitive.Root>
))

Label.displayName = "Label"
export { Label }
